import React, { useEffect, useState, forwardRef } from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  GDSStyleObject,
  StackLayout,
  Modal,
  ParagraphText,
  UtilityText,
  HeadingText,
  Button,
} from '@leagueplatform/genesis-core';
import { COB_LIBRARY_ASSET_KEYS } from '../../types/cob-library.types';

export const ErrorModal = forwardRef((props: any, ref: any) => {
  const { onClose, elementRef } = props;
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    // document.getElementById('errorBtn')?.click();
    setModalOpen(true);
  }, [modalOpen]);

  return (
    <Modal.Root
      open={modalOpen}
      data-testid="error_modal"
      onOpenChange={() => {
        setModalOpen((previous) => !previous);
      }}
    >
      <Modal.Trigger>
        <Modal.Trigger>
          <Button
            ref={elementRef}
            id="errorBtn"
            css={
              {
                visibility: 'hidden',
              } as GDSStyleObject
            }
          >
            Open Error Modal
          </Button>
        </Modal.Trigger>
      </Modal.Trigger>
      <Modal.Content
        showCloseButton={false}
        padding="$none"
        width={{ '@initial': 650, '@mobile': '100%' }}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <StackLayout
          css={{ textAlign: 'center', padding: '$three $three' }}
          horizontalAlignment="stretch"
        >
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              } as GDSStyleObject
            }
          >
            {' '}
            <img
              src={
                useStaticAsset(COB_LIBRARY_ASSET_KEYS.ATTENTION_ICON) as string
              }
              alt="right arrow icon"
              width="40px"
            />
          </Box>
          <Modal.Title>
            <HeadingText
              level="display"
              size="sm"
              css={{ padding: '$oneAndHalf $none' } as GDSStyleObject}
            >
              Oops! Something went wrong.
            </HeadingText>
          </Modal.Title>
          <ParagraphText emphasis="subtle">
            We’re sorry, but an unexpected error has occured
          </ParagraphText>
          <ParagraphText emphasis="subtle">Please try again</ParagraphText>
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'row',
                padding: '$two $four $one $four',
                justifyContent: 'space-around',
              } as GDSStyleObject
            }
          >
            <UtilityText
              css={{
                color: '$interactiveActionPrimary',
                cursor: 'pointer',
              }}
              id="closeBtn"
              ref={ref}
              onClick={onClose}
            >
              OK
            </UtilityText>
            {/* <Modal.Close>
            <Button width="fillContainer" css={{ marginTop: '$oneAndHalf' }}  onClick={onClose}>
              OK
            </Button>
          </Modal.Close> */}
          </Box>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
});
